export { default as Img200 } from './processed/200/Little-Drummer-Girl.jpg';
export { default as Img400 } from './processed/400/Little-Drummer-Girl.jpg';
export { default as Imgthumb } from './processed/thumb/Little-Drummer-Girl.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Little-Drummer-Girl.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Little-Drummer-Girl.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      225,
      214,
      103
    ],
    "_population": 125,
    "_hsl": [
      0.1516393442622951,
      0.6703296703296703,
      0.6431372549019607
    ]
  },
  "LightVibrant": {
    "_rgb": [
      250,
      240,
      113
    ],
    "_population": 908,
    "_hsl": [
      0.15450121654501217,
      0.9319727891156463,
      0.7117647058823529
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      40,
      33
    ],
    "_population": 114,
    "_hsl": [
      0.01555555555555555,
      0.5319148936170212,
      0.27647058823529413
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      136,
      94
    ],
    "_population": 266,
    "_hsl": [
      0.09722222222222221,
      0.288,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      213,
      180
    ],
    "_population": 362,
    "_hsl": [
      0.21212121212121207,
      0.28205128205128216,
      0.7705882352941177
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      66,
      48
    ],
    "_population": 2251,
    "_hsl": [
      0.08108108108108113,
      0.2781954887218045,
      0.26078431372549016
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Little-Drummer-Girl.js